import { BillingEnum } from "../../enums/billing-enum";
import { EquipmentEnum } from "../../enums/equipment-enum";
import {
  GenericStatusEnum,
  GenericStatusEnumById,
} from "../../enums/generic-status-enum";
import {
  ShipmentStatusEnum,
  ShipmentStatusEnumById,
} from "../../enums/shipment-status-enum";
import {
  ShipmentItemStatus,
  ShipmentItemStatusEnumById,
} from "../../enums/shipmentItemStatus";

export const equipmentsStatusColorMap = {
  [EquipmentEnum.RENTED]: {
    label: "Alugado",
    bgColor: "#D4EDDA",
    color: "#155724",
  }, // * Alugado
  [EquipmentEnum.AWAITING_SHIPMENT]: {
    label: "Aguardando Carregamento",
    bgColor: "#CCE5FF", // azul bem claro
    color: "#004085", // azul escuro
  }, // * Aguardando Carregamento
  [EquipmentEnum.REMOVED_FROM_SHIPMENT]: {
    label: "Retirado do carregamento",
    bgColor: "#EDE7F6",
    color: "#4527A0",
  }, // * Retirado do carregamento
  [EquipmentEnum.AWAITING_REPLACEMENT]: {
    label: "Aguardando Substituição",
    bgColor: "#FFF3CD",
    color: "#856404",
  }, // * Aguardando Substituição
  [EquipmentEnum.RESERVED]: {
    label: "Reservado",
    bgColor: "#007BFF",
    color: "#fff",
  }, // * Reservado
  [EquipmentEnum.INTERNAL_USE]: {
    label: "Uso Interno",
    bgColor: "#6A5ACD",
    color: "#fff",
  }, // * Uso Interno
  [EquipmentEnum.MAINTENANCE]: {
    label: "Em Manutenção",
    bgColor: "#E2E3E5",
    color: "#484541",
  }, // * Em Manutenção
  [EquipmentEnum.WARRANTY]: {
    label: "Garantia",
    bgColor: "#D1ECF1",
    color: "#0C5460",
  }, // * Garantia
  [EquipmentEnum.AVAILABLE]: {
    label: "Disponível para locação",
    bgColor: "#FEFEFE",
    color: "#4D4C4CFF",
  }, // * Disponível para locação
  [EquipmentEnum.DISABLED]: {
    label: "Desabilitado",
    bgColor: "#F8D7DA",
    color: "#721C24",
  }, // * Baixado
  [EquipmentEnum.ON_THE_WAY]: {
    label: "Em Rota",
    bgColor: "#EFE6DC",
    color: "#5C3A21",
  }, // * Em Rota
  [EquipmentEnum.RETURNED]: {
    // * Valor ficticio para o status EM DEVOLUÇÃO, somente para o frontend mostrar esse badge
    label: "Em Devolução",
    bgColor: "#FF8800",
    color: "#ffff",
  }, // * Em Devolução
};

export const genericStatusColorMap = {
  [GenericStatusEnumById[GenericStatusEnum.NOT_ATTENDED]]: {
    bgColor: "#FFF9C4", // Amarelo
    color: "#856404",
  },
  [GenericStatusEnumById[GenericStatusEnum.PARTIALLY_ATTENDED]]: {
    bgColor: "#FFF9C4", // Verde Claro
    color: "#1B5E20",
  },
  [GenericStatusEnumById[GenericStatusEnum.FULLY_ATTENDED]]: {
    bgColor: "#C8E6C9", // Verde
    color: "#1B5E20",
  },
  [GenericStatusEnumById[GenericStatusEnum.CANCELED]]: {
    bgColor: "#F8D7DA", // Vermelho claro
    color: "#721C24",
  },
};

export const shipmentStatusColorMap = {
  [ShipmentStatusEnumById[ShipmentStatusEnum.PENDING]]: {
    bgColor: "#FFF9C4", // Amarelo (Pendente)
    color: "#856404",
  },
  [ShipmentStatusEnumById[ShipmentStatusEnum.DELIVERED]]: {
    bgColor: "#C8E6C9", // Verde (Entregue)
    color: "#1B5E20",
  },
  [ShipmentStatusEnumById[ShipmentStatusEnum.CANCELED]]: {
    bgColor: "#F8D7DA", // Vermelho claro (Cancelado)
    color: "#721C24",
  },
  [ShipmentStatusEnumById[ShipmentStatusEnum.PARTIALLY_ATTENDED]]: {
    bgColor: "#FFF9C4",
    color: "#1B5E20",
  },
  [ShipmentStatusEnumById[ShipmentStatusEnum.WAITING_FOR_INVOICE]]: {
    bgColor: "#E3F2FD",
    color: "#1565C0",
  },
};

export const shipmentItemStatusColorMap = {
  [ShipmentItemStatusEnumById[ShipmentItemStatus.AGUARDANDO_CONFIRMACAO]]: {
    bgColor: "#FFF9C4", // Amarelo (Pendente)
    color: "#856404",
  },
  [ShipmentItemStatusEnumById[ShipmentItemStatus.ENTREGUE]]: {
    bgColor: "#C8E6C9", // Verde (Entregue)
    color: "#1B5E20",
  },
  [ShipmentItemStatusEnumById[ShipmentItemStatus.CANCELADO]]: {
    bgColor: "#F8D7DA", // Vermelho claro (Cancelado)
    color: "#721C24",
  },
  [ShipmentItemStatusEnumById[ShipmentItemStatus.PARCIALMENTE_ATENDIDO]]: {
    bgColor: "#FFF9C4",
    color: "#1B5E20",
  },
};

export const billStatusColorMap = {
  [BillingEnum.APPROVED]: {
    bgColor: "#C8E6C9",
    color: "#1B5E20",
  },
  [BillingEnum.DRAFT]: {
    bgColor: "#E2E3E5",
    color: "#484541",
  },
  [BillingEnum.PENDING]: {
    bgColor: "#FFF9C4",
    color: "#856404",
  },
  [BillingEnum.CANCELLED]: {
    bgColor: "#F8D7DA",
    color: "#721C24",
  },
};

export const maintenanceStatusColorMap = {
  "EM ABERTO": {
    bgColor: "#FFF9C4", // Amarelo
    color: "#856404",
  },
  FECHADO: {
    bgColor: "#C8E6C9", // Verde
    color: "#1B5E20",
  },
};
